module.exports = __webpack_public_path__ + "img/Plastic006_1K_Normal.b38e6f43.jpg";